import React, { useEffect } from "react";
import { DateInput } from "semantic-ui-calendar-react";
import { Button, Form, Label, Select, TextArea } from "semantic-ui-react";
import useCustomerReview from "@common/components/hooks/useCustomerReview";

const InputLabel = ({ question, isPrimary, hideLabel }) => {
  if (hideLabel) {
    return <></>;
  }
  return isPrimary ? (
    <label>{question}</label>
  ) : (
    <span className="ml-1">{question}</span>
  );
};

export const QuestionWrapper = ({
  question,
  error,
  isPrimary,
  children,
  hideLabel,
  fullWidth = false,
  disabled,
}) => {
  const style = fullWidth
    ? {}
    : {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      };

  return (
    <Form.Field error={error} className="mb-1">
      <div style={style}>
        <InputLabel
          question={question}
          isPrimary={isPrimary}
          hideLabel={hideLabel}
        />
        {children}
      </div>
      {error && (
        <Label prompt color="red" pointing="above" basic>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export const YesNoQuestion = (props) => {
  const { name, disabled } = props;
  const { form, onChange } = useCustomerReview();

  return (
    <div>
      <QuestionWrapper {...props}>
        <Button.Group>
          <Button
            color={form[name] === true ? "green" : null}
            onClick={(e) => onChange(e, { name, value: true })}
            disabled={disabled}
          >
            Yes
          </Button>
          <Button
            color={form[name] === false ? "red" : null}
            onClick={(e) => onChange(e, { name, value: false })}
            disabled={disabled}
          >
            No
          </Button>
        </Button.Group>
      </QuestionWrapper>
    </div>
  );
};

export const TextAreaQuestion = (props) => {
  const { name, question, hidden, disabled } = props;
  const { form, onChange } = useCustomerReview();

  useEffect(() => {
    if (hidden) {
      onChange(null, { name, value: null });
    }
  }, [hidden]);

  if (hidden) {
    return <></>;
  }

  return (
    <QuestionWrapper {...props}>
      <TextArea
        placeholder={question}
        onChange={onChange}
        name={name}
        disabled={disabled}
      >
        {form[name]}
      </TextArea>
    </QuestionWrapper>
  );
};

export const DateQuestion = (props) => {
  const { hidden, name, disabled } = props;
  const { form, onChange } = useCustomerReview();

  if (hidden) {
    return <></>;
  }
  return (
    <QuestionWrapper {...props}>
      <DateInput
        name={name}
        onChange={onChange}
        dateFormat="YYYY-MM-DD"
        value={form[name]}
        disabled={disabled}
      />
    </QuestionWrapper>
  );
};

export const SelectQuestion = (props) => {
  const { form, onChange } = useCustomerReview();
  const { hidden, name, disabled } = props;

  if (hidden) {
    return <></>;
  }
  return (
    <QuestionWrapper {...props}>
      <Select
        options={props.options}
        name={name}
        onChange={onChange}
        value={form[name]}
        disabled={disabled}
      />
    </QuestionWrapper>
  );
};
